module.exports = __webpack_public_path__ + "img/classes_list.6f7a2555.png";